import React, { useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import { portalActions } from "../../store/portal-slice";
import { getLocalStore, setLocalStore } from "helpers/localStoreSrv";
// import whitelabelConfig from "@whitelabel-config";
// import { useUiState } from "helpers/useUiState";
import { useApi } from "helpers/useApi";
// import api from "helpers/api";
export const usePregnancyWeightSrv = () => {
    // const { isAppLoading } = useUiState();
    const dispatch = useDispatch();
    const { api } = useApi();
    const portalSessionMeta = useSelector((state: any) => state.portal.micrositeSession);
    const getPregnancyToolData=(payload:any)=> {
        return api.get(
          `/api/healthtool/gettooldata?toolCode=${payload.toolCode}&patientHealthToolID=${payload.patientHealthToolID}&registeredToolID=${payload.registeredToolID}`
        );
      }
   
      const generatePregnancyWeight=(payload:any)=> {
        console.log('httpgeneratePregnancyWeight', payload);
        return api.post(`/api/healthtool/register`, payload);
      }
     const UpdatePregnancyWeight=(payload:any)=> {
        return api.post(`/api/healthtool/inputtooldata`, payload);
      }
      const generatePregnancyWeightData=(payload:any)=> {
        return api.post(`/api/memberpass`, payload);
      }
     const GetPatientMobileSettings=()=> {
        return api.get(`/api/member/mobilesettings`);
      }
 
    const restoreMicrositeSession = (micrositeSession: any) => {
        console.log(micrositeSession);
        dispatch(portalActions.updateMicrositeSession(micrositeSession));
    }
    useEffect(() => {
        console.log(portalSessionMeta);
        if (!!portalSessionMeta.urlRef) setLocalStore('MS', portalSessionMeta)
    }, [portalSessionMeta])
    useEffect(() => {
        const prevMS = getLocalStore('MS');
        if (prevMS) restoreMicrositeSession(prevMS)
    }, [])
    return {getPregnancyToolData ,generatePregnancyWeight,UpdatePregnancyWeight,generatePregnancyWeightData,GetPatientMobileSettings}
}